import { useState, useEffect } from "react";
import {
  TextField,
  Box,
  Button,
  CardMedia,
  Card,
  Typography,
  Avatar,
  Menu,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseMagHeader } from "./UseMagHeader";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import { SketchPicker } from "react-color";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MagHeaderManage() {
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const navigate = useNavigate();
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { GetMagHeader, SetMagHeader } = UseMagHeader();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [state, setState] = useState({
    id: undefined,
    urL1: "/",
    urL2: "/",
  });
  const { isSmall } = useBreakpoints();
  const [imgState, setImgState] = useState({
    imageFile1: undefined,
    imageUrl1: undefined,
    imageFile2: undefined,
    imageUrl2: undefined,
  });

  const handleChangeImage1 = (file) => {
    setImgState({
      ...imgState,
      imageFile1: file[0],
      imageUrl1: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      imageFile2: file[0],
      imageUrl2: URL.createObjectURL(file[0]),
    });
  };

  useEffect(() => {
    setProgress(true);
    GetMagHeader((header) => {
      setImgState({
        ...imgState,
        imageUrl1: header.logo1 ? header.logo1 : "",
        imageUrl2: header.logo2 ? header.logo2 : "",
      });
      setState({
        id: header.id ? header.id : "",
        urL1: header.urL1 ? header.urL1 : "",
        urL2: header.urL2 ? header.urL2 : "",
      });
    }, true);
  }, []);

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/magmanagment" },
          {
            name: "مدیریت هدر",
            url: "/magHeaderManage",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 3,
          }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage1(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl1
                        ? imgState.imageUrl1
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: isSmall ? "100%" : "40%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL1 ? state.urL1 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL1: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 3,
          }}
          gridColumn="span 12"
        >
          <FileUploader
            multiple={true}
            handleChange={(evt) => handleChangeImage2(evt)}
            name="file"
            types={fileTypes}
            children={
              <Box sx={{ width: "120px", height: "auto" }}>
                <Card
                  sx={{
                    p: 1,
                    border: "1px",
                    borderStyle: "dashed",
                    borderColor: "secondary.main",
                    borderRadius: 4,
                    boxShadow: 0,
                    cursor: "pointer",
                    bgcolor: "#e0e0e0",
                  }}
                >
                  <CardMedia
                    component="img"
                    sx={{ width: "100%", height: "100%" }}
                    image={
                      imgState.imageUrl2
                        ? imgState.imageUrl2
                        : "/static/img/no-photos.png"
                    }
                  />
                </Card>
              </Box>
            }
          />
          <TextField
            // fullWidth
            sx={{
              width: isSmall ? "100%" : "40%",
              textarea: { direction: "rtl" },
            }}
            multiline
            maxRows={4}
            value={state.urL2 ? state.urL2 : ""}
            // error={errorState.urL1}
            label="لینک تصویر"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({ ...state, urL2: evt.target.value });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      </Box>
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
        <Box sx={{ my: 2 }} gridColumn="span 12">
          {/* <Link
            target="_blank"
            to={{
              pathname: "/menues",
            }}
          >
          </Link> */}
          <Button variant="contained" color="secondary">
            مدیریت منوها
          </Button>
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ my: 2, display: "flex", justifyContent: "center" }}
        >
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => {
              //   if (validateItem(state, setErrorState) == 200) {
              setProgress(true);
              SetMagHeader(
                state,
                imgState.imageFile1,
                imgState.imageFile2,
                (calback) => {
                  navigate("/magmanagment", {
                    state: { ...location.state, isBack: true },
                    replace: true,
                  });
                }
              );
              //   }
            }}
          >
            ثبت
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/magmanagment", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
